<template>
  <div class="page page-app">
    <div class="page-header">
        <div>
            <h2><WFTranslate k="page-trains">Download the VR Matkalla application</WFTranslate></h2>
            <img class="page-image" src="../../assets/pages/vr.png">
        </div>
        <WFTranslate k="page-trains-description"></WFTranslate>
    </div>
    <div class="transport">
        <div class="flex mb-4 buttons">
            <button @click="setType('departures')" class="btn btn-lg btn-border ml-4" :class="{'btn-active': type == 'departures'}"><WFTranslate k="departing-trains"></WFTranslate></button>
            <button @click="setType('arrivals')" class="btn btn-lg btn-border" :class="{'btn-active': type == 'arrivals'}"><WFTranslate k="arriving-trains"></WFTranslate></button>
        </div>
        <div class="frame-wrapper">
            <iframe :src="url" ref="frame" nwdisable></iframe>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        page: {
			type: Object,
			default: null
		},
    },
    computed: {
        ...mapState('wf', ['language']),
        url () {
            //return this.host + "app/" + this.screen[this.type] + "/table/?locale=" + this.language;
            return this.screen[this.type];
        }
    },
    data () {
        return {
            host: "https://timetables.3dwayfinder.com/",
            /*screen: {
                "departures": "jgbvirk9jwmkgbt5roprj8xq",
                "arrivals": "kocefv7tqy9l4mcmbi8zsb0z"
            },*/
            screen: {
                "departures": "https://junalahdot.fi/helsinki?command=fs&id=47&dt=dep&lang=1",
                "arrivals": "https://junalahdot.fi/helsinki?command=fs&id=47&dt=arr&lang=1"
            },
            type: "departures"
        }
    },
    watch: {
        language () {
            if(this.$refs.frame) {
                this.$refs.frame.contentWindow.postMessage({"locale": this.language}, this.host);
            }
        }
    },
    mounted () {
        window.addEventListener("message", (event) => {
            if(typeof event.data == "object") {
                let trip = event.data.trip;
                if(trip && trip.stopId) {
                    let index = trip.stopId.indexOf("HKI_");
                    if(index == 0) {
                        
                        let room = this.$wayfinder.getRoom("track-"+trip.stopId.substring(4, trip.stopId.length))
                        console.log(room, "track-"+trip.stopId.substring(4, trip.stopId.length));
                        if (room && room.pois.length > 0) {
                            this.$wayfinder.showPath(room.pois[0].getNode());
                        }
                    }
                    
                }

            }
        }, false);
    },
    methods: {
        showRoute (type, slug) {
            this.$emit('showRoute', type, slug)
        },
        viewOnMap (type, slug) {
            this.$emit("viewOnMap", type, slug);
        },
        setType (type) {
            this.type = type;
        }
    }
}
</script>

<style lang="less">
    .transport .frame-wrapper {
        width: 100%;
        height: 120rem;
        padding: 0;
        overflow: hidden;
    }
    .page .transport iframe {
        width: 400%;
        height: 360rem;
        transform: scale(0.4);
        transform-origin: 0 -8.5rem;
    }
    
    .transport .buttons {
        justify-content: center;
        margin-bottom: 1rem;

        button:first-child {
            margin-right: 1rem;
        }
    }
</style>